import React, { Component } from 'react';
import { Table, ButtonToolbar, Button, Grid, Row, Col, FormGroup, InputGroup, FormControl, HelpBlock, Label } from 'react-bootstrap';

import { ImageCommand } from '../commands/ImageCommand';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { TableButton } from '../../TableButton';

export class ImageDataIdentifier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: this.props.selectedData,
            formData: {
                id: 0,
                url: "",
                rotationAngle: 0,
                opacity: 1,
                file: null
            },
            styles: {
                text: null,
                rotationAngle: null,
                opacity: null
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            actions: {
                isLoading: true,
                isSaving: false,
                isDeleting: false
            },
            commands: {
                imageCommand: new ImageCommand()
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { table, actions } = this.state;

            actions.isLoading = true;
            table.data = [];

            this.setState({
                table: table,
                actions: actions
            });
        }

        const { commands } = this.state;

        commands.imageCommand.getAll(
            (a) => this.getAllSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // ---------------------------

    getAllSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    saveSuccessCallback(result) {
        const { actions } = this.state;

        const dataIdStr = `${result.id}`;
        actions.isSaving = false;

        this.setState({
            selectedData: dataIdStr,
            actions: actions,
            formData: {
                id: 0,
                url: "",
                rotationAngle: 0,
                opacity: 1
            },
            message: {
                show: true,
                message: "Imagem criada com sucesso",
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getAllData(true);

        // Set the new id to the parent component
        this.props.onSelectData(dataIdStr)
    }

    deleteSuccessCallback(message) {
        const { actions } = this.state;

        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getAllData(true);
    }

    listErrorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationsErrorCallback(message) {
        const { actions } = this.state;

        actions.isSaving = false;
        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        this.getAllData(true);
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onChangeValue(e, target) {
        const { formData } = this.state;
        formData[target] = e.target.value;

        if ("url" === target) {
            formData.file = null;
        }

        this.setState({
            formData: formData
        });
    }

    onChangeFile(event) {
        const { formData } = this.state;

        const uploadedFile = event.target.files[0];

        if (undefined !== uploadedFile) {
            formData.url = uploadedFile.name;
            formData.file = uploadedFile;

            this.setState({
                formData: formData
            });

            // Reset the input file value
            event.target.value = "";
        }
    }

    // -----------------------

    onSelectData(data) {
        const dataIdStr = `${data.id}`;

        this.props.onSelectData(dataIdStr)

        this.setState({
            selectedData: dataIdStr
        });
    }

    onDeleteData(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a imagem "${data.url}"?`,
                style: "warning",
                icon: "alert",
                argument: {
                    textId: data.id
                }
            }
        });
    }

    onAddData() {
        const { formData, commands } = this.state;

        let styles = {
            url: null,
            rotationAngle: null,
            opacity: null
        }

        if (0 >= formData.url.length) {
            styles.url = "error"
        }
        if (0 >= formData.rotationAngle.length || -360 > formData.rotationAngle || 360 < formData.rotationAngle) {
            styles.rotationAngle = "error"
        }
        if (0 >= formData.opacity.length || 0 > formData.opacity || 1 < formData.opacity) {
            styles.opacity = "error"
        }

        this.setState({
            styles: styles
        });

        if (null === styles.url && null === styles.rotationAngle && null === styles.opacity) {
            commands.imageCommand.save(
                formData,
                (a) => this.saveSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );
        }
    }

    onFileUploadButtonClick() {
        this.refs.imageUploader.click();
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions, commands } = this.state;

        if (isToExecute) {
            actions.isDeleting = true;

            commands.imageCommand.delete(
                argument.textId,
                (a) => this.deleteSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------------

    selectedData(obj) {
        const { selectedData } = this.state;
        if (`${obj.id}` === selectedData) {
            return (
                <h5>
                    <Label bsStyle="success" className="icon-ok icon-img">&nbsp;</Label>
                </h5>
            );
        }
        else {
            return (
                <TableButton icon="icon-select" title="Selecionar" onClick={() => this.onSelectData(obj)} />
            );
        }
    }

    render() {
        const { isLoading, isSaving, isDeleting } = this.state.actions;
        if (isLoading || isSaving || isDeleting) {
            return (
                <LoadingSpinner />
            );
        }

        const { selectedData, formData, styles, table, message, dialog } = this.state;
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Table responsive striped hover style={{ marginTop: 10 }}>
                                <thead>
                                    <tr>
                                        <th>Url</th>
                                        <th style={{ whiteSpace: "unset" }}>Rotação [-360..360]</th>
                                        <th style={{ whiteSpace: "unset" }}>Opacidade [0..1]</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((obj, idx) =>
                                            <tr key={`data-${idx}`}>
                                                <td style={{ whiteSpace: "unset" }}><a target="_blank" rel="noopener noreferrer" href={obj.url}>{undefined === obj.url ? "" : obj.url.split('/').slice(-1)}</a></td>
                                                <td>{obj.rotationAngle}&deg;</td>
                                                <td>{obj.opacity}</td>
                                                <td>{this.selectedData(obj)}</td>
                                                <td><TableButton disabled={`${obj.id}` === selectedData} icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteData(obj)} /></td>
                                            </tr>
                                        )
                                    }
                                    <tr>
                                        <td>
                                            <FormGroup controlId="formDataUrl"
                                                className="margin-bottom-0"
                                                validationState={styles.url} >
                                                <input
                                                    type="file"
                                                    ref="imageUploader"
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                    onChange={(a) => this.onChangeFile(a)} />
                                                <InputGroup bsSize="small">
                                                    <FormControl
                                                        type="text"
                                                        placeholder="URL"
                                                        value={formData.url}
                                                        onChange={(e) => this.onChangeValue(e, 'url')} />
                                                    <InputGroup.Button>
                                                        <Button onClick={() => this.onFileUploadButtonClick()}>Imagem</Button>
                                                    </InputGroup.Button>
                                                </InputGroup>
                                                <HelpBlock>{null === formData.file ? "Inserido URL" : "Carregada Imagem"}</HelpBlock>
                                            </ FormGroup>
                                        </td>
                                        <td className="cell-align-top">
                                            <FormGroup bsSize="small"
                                                controlId="formDataRotationAngle"
                                                className="margin-bottom-0"
                                                validationState={styles.rotationAngle} >
                                                <FormControl
                                                    type="number"
                                                    step={0.1}
                                                    min={-360}
                                                    max={360}
                                                    placeholder="Ângulo de Rotação"
                                                    value={formData.rotationAngle}
                                                    onChange={(e) => this.onChangeValue(e, 'rotationAngle')} />
                                            </ FormGroup>
                                        </td>
                                        <td className="cell-align-top">
                                            <FormGroup bsSize="small"
                                                controlId="formDataOpacity"
                                                className="margin-bottom-0"
                                                validationState={styles.opacity} >
                                                <FormControl
                                                    type="number"
                                                    step={0.1}
                                                    min={0}
                                                    max={1}
                                                    placeholder="Opacidade"
                                                    value={formData.opacity}
                                                    onChange={(e) => this.onChangeValue(e, 'opacity')} />
                                            </ FormGroup>
                                        </td>
                                        <td className="cell-align-top" colSpan={2}>
                                            <ButtonToolbar>
                                                <TableButton className="no-padding-top" icon="icon-plus" title="Adicionar" onClick={() => this.onAddData()} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={table.data.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                        </Col>
                    </Row>
                </Grid>
                
                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />
                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
